/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Analysis_UnsupportedInputs */

const en_api_error_task_analysis_unsupported = /** @type {(inputs: Api_Error_Task_Analysis_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This task type does not support AI analysis.`)
};

const pt_br2_api_error_task_analysis_unsupported = /** @type {(inputs: Api_Error_Task_Analysis_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este tipo de atividade não oferece análise por IA.`)
};

/**
* | output |
* | --- |
* | "This task type does not support AI analysis." |
*
* @param {Api_Error_Task_Analysis_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_analysis_unsupported = /** @type {((inputs?: Api_Error_Task_Analysis_UnsupportedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Analysis_UnsupportedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_analysis_unsupported(inputs)
	return pt_br2_api_error_task_analysis_unsupported(inputs)
});